export default "__VITE_ASSET__28a80c13__"